import { Tag } from 'src/app/people/models/tag';
import { PersonScenarioRequirement } from './personScenarioRequirement';

export class PersonCredentialScenario {
  public personCredentialScenarioTags: Tag[];
  /** will only get set when called the getByPersonScenarioId API */
  public requirements: PersonScenarioRequirement[] = [];

  constructor(
    public id: string,
    public credentialScenarioDefinitionId: string,
    public personId: string,
    public personName: string,
    public status: PersonCredentialScenarioStatus,
    public personCredentialId: string,
    public credentialName: string,
    public name: string,
    /**number between 0 and 100*/
    public percentComplete: number,
    public credentialDefinitionId: string,
    public personCredentialApplicationId: string,
    personCredentialScenarioTags: Tag[]
  ) {
    this.personCredentialScenarioTags = personCredentialScenarioTags
      ? personCredentialScenarioTags
      : [];
  }

  static parseWithRequirement(
    json: Partial<PersonCredentialScenario> & { requirements: PersonScenarioRequirement }
  ): PersonCredentialScenario {
    const model = PersonCredentialScenario.parse(json);
    model.requirements = json.requirements?.length
      ? json.requirements.map((requirement) => PersonScenarioRequirement.parse(requirement))
      : [];
    return model;
  }

  static parse(obj: Partial<PersonCredentialScenario>): PersonCredentialScenario {
    if (obj == null) return null;
    return new PersonCredentialScenario(
      obj.id,
      obj.credentialScenarioDefinitionId,
      obj.personId,
      obj.personName,
      obj.status,
      obj.personCredentialId,
      obj.credentialName,
      obj.name,
      obj.percentComplete,
      obj.credentialDefinitionId,
      obj.personCredentialApplicationId,
      obj.personCredentialScenarioTags
    );
  }

  public getStatusClass(): string {
    switch (this.status) {
      case PersonCredentialScenarioStatus.InProgress:
        return 'active';
      case PersonCredentialScenarioStatus.Completed:
        return 'accepted';
      case PersonCredentialScenarioStatus.Archived:
        return 'archived';
    }
  }

  public getStatusText(): string {
    switch (this.status) {
      case PersonCredentialScenarioStatus.InProgress:
        return 'In Progress';
      case PersonCredentialScenarioStatus.Completed:
        return 'Completed';
      case PersonCredentialScenarioStatus.Archived:
        return 'Archived';
    }
  }
}

export enum PersonCredentialScenarioStatus {
  InProgress = 'InProgress',
  Completed = 'Completed',
  Archived = 'Archived',
}
